import type { IFieldOptions } from '@axo/form/feature/form-input/types';

export const debtCreditCardOutstandingAmountFieldOption = {
  registerOptions: {
    required: 'Debt.CreditCard.OutstandingAmount.error.required',
    max: {
      value: 99_999,
      message: 'Debt.CreditCard.OutstandingAmount.error.amount',
    },
  },
  warningValidation: {
    message: (value) => {
      const amount = Number(value);
      if (amount > 75_000) {
        return 'Debt.CreditCard.OutstandingAmount.error.soft.amount';
      }
    },
  },
} satisfies IFieldOptions;

export const debtCreditCardMonthlyDebtPaymentFieldOption = {
  registerOptions: {
    shouldUnregister: true,
    deps: 'Debt/CreditCard/OutstandingAmount',
    required: 'Debt.CreditCard.MonthlyDebtPayment.error.required',
    max: {
      value: 99_999,
      message: 'Debt.CreditCard.MonthlyDebtPayment.error.amount',
    },
    validate: {
      amount: (value, form) => {
        const amount = Number(value);
        if (!amount) return;

        const outstanding = Number(form['Debt/CreditCard/OutstandingAmount']);
        if (amount >= outstanding) {
          return 'Debt.CreditCard.MonthlyDebtPayment.error.amount';
        }
      },
    },
  },
  warningValidation: {
    message: (value) => {
      const amount = Number(value);
      if (amount > 75_000) {
        return 'Debt.CreditCard.MonthlyDebtPayment.error.soft.amount';
      }
    },
  },
} satisfies IFieldOptions;
